import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-hot-toast';
// import { Document, Page } from 'react-pdf';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const ShowPdfModal = (props) => {
    const AWS_Url = process.env.REACT_APP_AWSURL
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageDimensions, setPageDimensions] = useState({ width: 0, height: 0 });
    const [pdfError, setPdfError] = useState(false);
    const [loading, setLoading] = useState(true);
    const modalBodyRef = useRef(null);

    useEffect(() => {
        function updateDimensions() {
            if (modalBodyRef.current) {
                const modalBodyWidth = modalBodyRef.current.clientWidth;
                const modalBodyHeight = modalBodyRef.current.clientHeight;
                setPageDimensions({
                    width: modalBodyWidth,
                    height: modalBodyHeight
                });
            }
        }

        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, [props.show]);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setLoading(false);
        setPdfError(false);
    };

    const onDocumentLoadError = (error) => {
        console.error('PDF load error:', error);
        setPdfError(true);
        setLoading(false);
        // Check if it's a file not found error
        const errorMessage = error?.message || error?.toString() || '';
        const isFileNotFound = errorMessage.includes('ENOENT') || 
                              errorMessage.includes('no such file') ||
                              errorMessage.includes('404') ||
                              errorMessage.includes('Failed to fetch');
        
        if (isFileNotFound) {
            // File not found - don't show error toast, just show message in UI
            setPdfError(true);
        } else {
            // Other errors - show toast
            toast.error('Failed to load PDF file. The file may not be available.');
        }
    };

    return (
        <>
            <Modal show={props.show} onHide={() => {
                props.handleClose()
                setPageNumber(1)
                setPdfError(false)
                setLoading(true)
            }} size='lg'>
                {/* <Modal show={props.show} onHide={props.handleClose} fullscreen={true}> */}
                <Modal.Header closeButton>
                    {/* <Modal.Title>Are you sure to submit all the answers</Modal.Title> */}
                </Modal.Header>
                <Modal.Body ref={modalBodyRef}>
                    {pdfError ? (
                        <div className='d-flex flex-column justify-content-center align-items-center py-5'>
                            <p className='text-muted'>PDF file not available or could not be loaded.</p>
                            <p className='text-muted small'>The file may have been removed or is temporarily unavailable.</p>
                        </div>
                    ) : (
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                            {loading && (
                                <div className='py-5'>
                                    <p className='text-muted'>Loading PDF...</p>
                                </div>
                            )}
                            {props?.pdfItem && (
                                <Document 
                                    file={`${AWS_Url}${props?.pdfItem}`} 
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    onLoadError={onDocumentLoadError}
                                    loading={
                                        <div className='py-5'>
                                            <p className='text-muted'>Loading PDF...</p>
                                        </div>
                                    }
                                    error={
                                        <div className='py-5'>
                                            <p className='text-muted'>Failed to load PDF file.</p>
                                        </div>
                                    }
                                >
                                    {numPages && (
                                        <>
                                            <Page pageNumber={pageNumber} width={pageDimensions?.width} />
                                            <p>
                                                Page {pageNumber} of {numPages}
                                            </p>
                                        </>
                                    )}
                                </Document>
                            )}
                        </div>
                    )}
                    {!pdfError && numPages && (
                        <div className='d-flex justify-content-between align-items-center mt-3'>
                            <Button onClick={() => setPageNumber(pageNumber - 1)} disabled={pageNumber <= 1}>Prev</Button>
                            <Button onClick={() => setPageNumber(pageNumber + 1)} disabled={pageNumber >= numPages}>Next</Button>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        props.handleClose()
                        setPageNumber(1)
                    }}>
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    )
};

export default ShowPdfModal